import React, {useMemo, useState} from 'react';
import {ManufacturerDisabledProperties} from 'shared/ManufacturerDisabledProperties';
import {Header} from 'shared/components/Header/Header';
import {SidebarRight} from 'shared/components/Header/SidebarRight';
import {SidebarLeft} from 'shared/components/Header/SidebarLeft';
import {MobileMenu} from 'shared/components/Header/MobileMenu';
import {Suspended} from 'shared/Suspended';
import {Container} from 'react-bootstrap';
import {useIsHandheldPortrait} from 'shared/helpers/DeviceSize';
import {useAppContext} from 'contexts';
import {useHideMobileMenu} from 'shared/helpers/useHideMobileMenu';
import {useRoomPreview} from 'components/customer/RoomPlanner/components/helpers/RoomPreview';
import {mobile} from 'shared/Breakpoints';
import styled from 'styled-components';

interface LayoutProps {
    withSidebar?: boolean;
    children: React.ReactElement;
}

const Layout = ({withSidebar, children}: LayoutProps) => {
    const isHandheldPortrait = useIsHandheldPortrait();
    const previewMode = useRoomPreview();

    const {userProfile: realUserProfile} = useAppContext();
    const emptyUserProfile = useMemo(() => ({}) as typeof realUserProfile, []);

    const userProfile = previewMode ? emptyUserProfile : realUserProfile;
    const visible = true;
    const {hideMenu} = useHideMobileMenu();
    const [mobileMenuHeight, setMobileMenuHeight] = useState<number>();

    return (
        <>
            {withSidebar && !previewMode ? <SidebarLeft /> : null}

            <MainContent
                // other styles use the mobile class to tell the menu is shown
                className={`mainContent${
                    typeof mobileMenuHeight === 'undefined' ? '' : ' mobile'
                }`}
                $mobileMenuHeight={mobileMenuHeight}
                style={{marginBottom: visible ? '0' : '-68px'}}>
                <Header visible={visible} userProfile={userProfile} />

                <section className="component-section">
                    {userProfile &&
                    Object.keys(userProfile).length &&
                    (userProfile.isSuspended || userProfile.isBanned) ? (
                        <Suspended userProfile={userProfile} />
                    ) : (
                        <Container className="content-container">
                            {children}
                        </Container>
                    )}
                </section>

                {!previewMode ? <ManufacturerDisabledProperties /> : null}
                {isHandheldPortrait && !hideMenu && !previewMode ? (
                    <MobileMenu onHeightChange={setMobileMenuHeight} />
                ) : null}
            </MainContent>

            {withSidebar ? <SidebarRight /> : null}
        </>
    );
};

const MainContent = styled.section<{$mobileMenuHeight?: number}>`
    min-width: 0;

    ${mobile<{$mobileMenuHeight?: number}>`
    /* 
        The mobile menu floats over the bottom of the page and its height is
        not static, so the page is padded by its height, which it reports.
    */
    padding-bottom: ${({$mobileMenuHeight = 0}) => $mobileMenuHeight}px;
        > section {
            > div {
                padding-bottom: 10px; 
            }
        }
    `}
`;

export default Layout;
